import SaveButton from "../../../../components/SaveButton";
import React, { useState, useEffect } from "react";

import { useGetUserPermission } from "./hooks/useGetUserPermission";
import { useUpdateUser } from "./hooks/useUpdateUserPermission";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import MaterialExTable from "../../../../components/tables/MaterialExTable";
import { XCircleIcon } from "@heroicons/react/24/solid";

const UserPermissionTable = ({ userId, setUser }) => {
  const { data } = useGetUserPermission(userId);
  const [userData, setUserData] = useState([]);
  const updateUserPermissions = useUpdateUser();
  const [updateUser, setUpdateUser] = useState(false);
  const [updatedPermissions, setUpdatedPermissions] = useState([]);

  useEffect(() => {
    if (data?.length >= 0 && userData.length === 0) {
      setUserData(data);
    }
  }, [data, userData.length]);

  const handleSubmit = () => {
    setUpdateUser(true);
  };
  const Update = () => {
    updateUserPermissions(updatedPermissions);
    setUpdateUser(false);
  };
  const updatePermission = (e, row, name) => {
    const updates = userData.map((data) =>
      data.permissions?.[name]?.permissionId ===
      row.permissions?.[name]?.permissionId
        ? {
            ...data,
            permissions: {
              ...data.permissions,
              [name]: { ...data.permissions[name], status: e.target.checked },
            },
          }
        : data
    );

    const existing = updatedPermissions?.filter(
      (a) => a.permissionId === row.permissions?.[name].permissionId
    );

    if (existing.length > 0) {
      const edited = updatedPermissions.map((a) => {
        if (a.permissionId === row.permissions?.[name].permissionId) {
          return { ...a, status: e.target.checked };
        } else {
          return a;
        }
      });

      setUpdatedPermissions(edited);
    } else {
      setUpdatedPermissions([
        ...updatedPermissions,
        {
          permissionId: row.permissions?.[name].permissionId,
          status: e.target.checked,
          userId,
        },
      ]);
    }

    setUserData(updates);
  };
  const materialcolumns = [
    { title: "NAME", field: "name" },
    // { title: "Description", field: "description" },
    // { title: "Module", field: "moduleName" },
    // { title: "Sub Module", field: "subModuleName" },

    {
      title: "VIEW",
      field: "permissions.view.status",
      render: (row) => {
        return (
          <div>
            {!row.permissions?.view ? (
              <p></p>
            ) : (
              <input
                type="checkbox"
                checked={row.permissions?.view?.status}
                value={row.permissions?.view?.status}
                onChange={(e) => {
                  updatePermission(e, row, "view");
                }}
              />
            )}
          </div>
        );
      },
    },
    {
      title: "ADD",
      center: true,
      field: "permissions.add.status",
      render: (row) => {
        return (
          <div>
            {!row.permissions.add ? (
              <p></p>
            ) : (
              <input
                type="checkbox"
                checked={row.permissions?.add?.status}
                value={row.permissions?.add?.status}
                onChange={(e) => {
                  updatePermission(e, row, "add");
                }}
              />
            )}
          </div>
        );
      },
    },
    {
      title: "EDIT",
      center: true,
      field: "permissions.edit.status",
      render: (row) => {
        return (
          <div>
            {!row.permissions?.edit ? (
              <p></p>
            ) : (
              <input
                type="checkbox"
                checked={row.permissions?.edit?.status}
                value={row.permissions?.edit?.status}
                onChange={(e) => {
                  updatePermission(e, row, "edit");
                }}
              />
            )}
          </div>
        );
      },
    },
    {
      title: "DELETE",
      center: true,
      field: "permissions.delete.status",
      render: (row) => {
        return (
          <div>
            {!row.permissions?.delete ? (
              <p></p>
            ) : (
              <input
                type="checkbox"
                checked={row.permissions?.delete?.status}
                value={row.permissions?.delete?.status}
                onChange={(e) => {
                  updatePermission(e, row, "delete");
                }}
              />
            )}
          </div>
        );
      },
    },
    {
      title: "DOWNLOAD",
      center: true,
      field: "permissions.download.status",
      render: (row) => {
        return (
          <div className="text-center">
            {!row.permissions?.download ? (
              <p></p>
            ) : (
              <input
                type="checkbox"
                checked={row.permissions?.download?.status}
                value={row.permissions?.download?.status}
                onChange={(e) => {
                  updatePermission(e, row, "download");
                }}
              />
            )}
          </div>
        );
      },
    },
  ];
  return (
    <div className="space-y-5">
      <div className="App">
        <MaterialExTable
          columns={materialcolumns}
          data={userData}
          options={{
            showTitle: "User's Permission",
            loadingType: "overlay",
            exportCsv: (columns, data) => {
              alert(
                "You should develop a code to export " + data.length + " rows"
              );
            },

            grouping: false,
            pageSize: 10,
            headerStyle: {
              textAlign: "center",
            },
            rowStyle: {
              textAlign: "center",
            },
          }}
        />
      </div>

      <ConfirmBoxModal
        ModalTitle="Update User Permission"
        qConfirmation=" Are you sure you want to update this?"
        isOpen={updateUser}
        onClose={() => setUpdateUser(true)}
        onClickFunction={() => {
          Update();
        }}
      />
      <div className="flex justify-end items-center gap-2  mt-4">
        <div>
          <SaveButton
            className={"opacity-100 "}
            disabled={false}
            buttonText="Save"
            onClick={() => {
              handleSubmit();
            }}
          />
        </div>
        <div>
          <button
            className="px-3 py-1 text-xs text-white gap-x-2 bg-btnClose rounded-full flex items-center justify-center font-semibold hover:bg-gray-400 box-shadow"
            onClick={() => setUser(-1)}
          >
            <XCircleIcon className="h-4 w-4" />
            <div>Close</div>
          </button>
        </div>
      </div>
      {/* <TableNoBorder columns={columns} data={UserPData} /> */}
    </div>
  );
};
export default UserPermissionTable;
